// @flow
import * as React from 'react';
import clsx from 'clsx';

import styles from './GandiVector.scss';

export function GandiSVG(): React.Element<'svg'> {
  return (
    <svg height="50" width="50" viewBox="0 0 50 50">
      <path d="M38.6 16.5c1-1.3.6-3.2-.7-4.1-1.3-.9-3.1-.6-4.1.7-1.4 1.9-2.9 3.2-4.6 4-1.4.6-2.9.9-4.6 1-1.7-.1-3.1-.4-4.4-1-1.8-.8-3.3-2.1-4.6-4-.9-1.3-2.8-1.6-4.1-.7-1.3.9-1.6 2.8-.7 4.1 2.9 4.2 8 6.3 8.6 6.5-2.3 1.7-4.8 4-5.9 7.1-1.2 3.3-1.2 6.9 0 10 1.2 3.1 3.4 5.5 6.3 7 3.2 1.6 7.2 1.6 10.8 0 3.8-1.7 6.2-4.8 6.6-8.3.4-3.7-1.4-7-4.5-8.4-3.2-1.4-6.8-.4-9.3 2.6-1 1.3-.8 3.1.5 4.1 1.3 1 3.1.8 4.1-.5.7-.9 1.5-1.2 2.3-.9.6.3 1.2 1.1 1.1 2.5-.1 1.4-1.3 2.7-3.2 3.6-2 .9-4.2.9-5.7.1-1.6-.8-2.8-2.2-3.5-3.9-.5-1.3-.9-3.4 0-5.8.7-1.9 2.4-3.6 5.5-5.5 1.3-.8 2.7-1.6 4-2.3-.1.1 7.1-3.8 10.1-7.9zm-14.1-15c-3.7 0-6.8 3-6.8 6.8 0 3.7 3 6.8 6.8 6.8 3.7 0 6.8-3 6.8-6.8 0-3.7-3-6.8-6.8-6.8zm0 8.8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
    </svg>
  );
}

function GandiVector(): React.Element<typeof React.Fragment> {
  return (
    <>
      <span className={clsx(styles.GandiVector, styles.GandiVectorLeft)}>
        <GandiSVG />
      </span>

      <span className={clsx(styles.GandiVector, styles.GandiVectorRight)}>
        <GandiSVG />
      </span>
    </>
  );
}

export default GandiVector;
